import { useEffect } from 'react';
import ImpactHero from './components/ImpactHero';
import ImpactStats from './components/ImpactStats';
import OregonDogRescueSection from './components/OregonDogRescueSection';
import AboutPuplandia from './components/AboutPuplandia';
import HowItWorksSection from './components/HowItWorksSection';
import ImpactTimeline from './components/ImpactTimeline';
import WhyTheDogsFeature from './components/WhyTheDogsFeature';
import MilitaryDiscountCallout from './components/MilitaryDiscountCallout';
import ReferralCrossPromo from './components/ReferralCrossPromo';
import ImpactNewsletter from './components/ImpactNewsletter';
import ImpactCta from './components/ImpactCta';
import { removeJsonLd } from '../../lib/schemaBuilder';
import { injectFAQSchema, removeFAQSchema } from '../../lib/safeSchema';
import { pageFaqs } from '../../mocks/pageFaqs';
import { useSEOHead } from '../../hooks/useSEOHead';

export default function CommunityImpactPage() {
  useSEOHead({
    title: 'Community Impact | Oregon Dog Rescue | Rockhound Auto',
    description: 'Every car sold helps Oregon Dog Rescue save lives. Learn how Rockhound Auto\'s partnership with Puplandia supports local animal welfare on the Oregon Coast.',
    keywords: 'Oregon Dog Rescue, Puplandia, community impact, animal welfare, Oregon Coast charity, car sales for charity',
    canonicalUrl: 'https://rockhoundauto.com/community-impact',
  });

  useEffect(() => {
    injectFAQSchema(
      'schema-community-impact-faq',
      pageFaqs.communityImpact,
      'https://rockhoundauto.com/community-impact#faqpage'
    );

    return () => {
      removeFAQSchema('schema-community-impact-faq');
    };
  }, []);

  return (
    <>
      <ImpactHero />
      <ImpactStats />
      <OregonDogRescueSection />
      <AboutPuplandia />
      <MilitaryDiscountCallout />
      <HowItWorksSection />
      <ImpactTimeline />
      <WhyTheDogsFeature />
      <ReferralCrossPromo />
      <ImpactNewsletter />
      <ImpactCta />
    </>
  );
}